module.exports = __webpack_public_path__ + "fonts/Manrope-500-cyrillic-ext7_6b3b5bc.woff2";